<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-0 pa-2 d-flex justify-space-between">
            <div>
                <v-btn
                        :disabled="false"
                        @click="exportReportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
            </div>
            <div style="width: 30%">
                <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                ></v-text-field>
            </div>
        </div>
        <div class="flex-grow-1 of-y">
            <v-data-table
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="rows"
                    :options="{itemsPerPage: rows.length}"
            ></v-data-table>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        data: Array,
        reportType: String,
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: null,
            headers: [
                {text: "Farm", value: "farm"},
                {text: "Employee", value: "employee"},
                {text: "Employee Code", value: "employeeCode"},
                {text: "Checked In", value: "checkIn"},
                {text: "Minutes Late", value: "minutesLate"},
            ],
            exportingData: false,
        }
    },
    watch: {},
    methods: {
        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/latecomers/export`,
                    {
                        start: this.selectedDate,
                        farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    },
                    `Latecomers Summary ${format(this.selectedDate, 'yyyy-MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(["farms", "availableFarms", "availableFarmIDs"]),
        rows() {
            return this.data.map(row => {
                return {
                    ...row,
                    farm: row.farmRef.description,
                    employee: row.empRef.fullName,
                    employeeCode: row.empRef.empCode,
                }
            })
                    .filter((row) => this.selectedFarm ? row.fkFarm === this.selectedFarm : true)
                    .filter(row => this.availableFarmIDs.includes(row.fkFarm))
        }
    },
}
</script>

<style scoped>

</style>